// extracted by mini-css-extract-plugin
module.exports = {"cls1":"_404-Title-module--cls1--23Fbh","cls2":"_404-Title-module--cls2--3g4a7 _404-Title-module--cls1--23Fbh"};